import Loader from '@/components/loader'
import { ErrorBoundary } from '@suspensive/react'
import { Navigate, Outlet } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useCustomerAccountAuthentication } from './use-customer-account-authentication'

export function AppLayout() {
  const { isAuthenticated, isValidating } = useCustomerAccountAuthentication()

  if (isValidating) {
    return <Loader />
  }

  if (!isAuthenticated) {
    return <Navigate to='/customer/login' replace />
  }

  return (
    <ErrorBoundary
      fallback={null}
      onError={(error) => {
        toast.error(error.message)
      }}
    >
      <Outlet />
    </ErrorBoundary>
  )
}
